import ChevronLeft from '@/components/icons/chevron-left'
import { RouteIcon } from 'lucide-react'
import Link from 'next/link'

export default function ManageChampionshipEventToolbar({ event }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-wrap items-center gap-2">
        <Link
          href={`/manage/${event.championship.communityId}/racing/${event.championshipId}/events`}
        >
          <ChevronLeft className="h-5 w-5 stroke-white stroke-2 hover:opacity-80" />
        </Link>

        <h4 className="text-h-4-sm">{event.name}</h4>

        {event.eventRoundNumber && (
          <div className="text-nowrap rounded-full bg-shades-0 px-4 py-2 text-xs font-medium text-shades-100 opacity-90">
            Event {event.eventRoundNumber} / {event.championship._count.events}
          </div>
        )}
      </div>

      {(event.track?.name || event.trackMeta?.name) && (
        <div className="flex items-center gap-2">
          <div className="relative flex size-8 items-center rounded-sm bg-neutral-blue-700">
            <RouteIcon className="mx-auto size-5 stroke-neutral-blue-200 stroke-2" />
          </div>

          <p className="text-p-1 font-semibold text-shades-0">Track</p>

          <p className="truncate-1 break-all text-p-1">
            {event.track?.name ?? event.trackMeta?.name}
          </p>
        </div>
      )}
    </div>
  )
}
